'use strict';
import template from './listado-general.html';
import controller from './listado-general.controller';

const ListadoGeneralComponent = {
  controller,
  template
};

export default ListadoGeneralComponent;


// WEBPACK FOOTER //
// ./src/app/components/listados/listado-general/listado-general.component.js